import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useRef } from 'react';

const LessonButton = ({ lesson }) => {

  const navigate = useNavigate();

  const link = `./assets/pdf/technical-sheets/${lesson.filename}-${sessionStorage.getItem("lang") ? sessionStorage.getItem("lang") : "fr"}.pdf`;

  const handleClick = (ev) => {
    ev.preventDefault();
    navigate(`/lesson`, {
      state: {
        link,
        title: lesson.title
      }
    });
  }
  

  return (
    <li className='lesson-button'>
      <button onClick={handleClick} dangerouslySetInnerHTML={{ __html: `
      <span>
        <strong>Saison ${lesson.saison} - Episode ${lesson.episode} :</strong>
        <p>${lesson.title}</p>
      </span>
      <img src="./assets/images/download-icon.svg" alt="Télécharger la fiche" />
      ` }}></button>
    </li>
  );
};

export default LessonButton;